/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Chat_Mentions_Link_File_Description_No_SpaceInputs */



/**
* | output |
* | --- |
* | "\"{name}\" is not linked to this project yet, so the assistant cannot read it." |
*
* @param {Chat_Mentions_Link_File_Description_No_SpaceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_mentions_link_file_description_no_space = /** @type {((inputs: Chat_Mentions_Link_File_Description_No_SpaceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Mentions_Link_File_Description_No_SpaceInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`„${i?.name}“ ist noch nicht mit diesem Projekt verknüpft und kann daher nicht gelesen werden.`)
	return /** @type {LocalizedString} */ (`"${i?.name}" is not linked to this project yet, so the assistant cannot read it.`)
});